import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
const Footer = () => {
  return (
    <footer className="footer" id='contactus'>
      <Container fluid>
      <Row className="px-3 py-4 footerrow text-center">
          {/* Contact Us Column */}
          <Col lg={6} md={6} sm={12} xs={12} className='my-2'>
            <h2>
              <button className="btns">Contact Us</button>
            </h2>
            <div className="contact-details">
              <p>
                <FaPhoneAlt className="icon" /> +91-9462228897
              </p>
              <p>
                <FaEnvelope className="icon" /> business@seedlogix.in
              </p>
            </div>
          </Col>

          {/* Head Office Column */}
          <Col lg={6} md={6} sm={12} xs={12} className='my-2'>
            <h2>
              <button className="btns">Head Office</button>
            </h2>
            <p>
              P N 4, BHASKAR ENCLAVE,
              <br />
              NEAR O.T.S J.L.N. MARG JAIPUR,
              <br />
              302017
              <br />
              Rajasthan, India
            </p>
          </Col>
        </Row>
        <hr className="my-4" />
        <div className="text-center" style={{ marginBottom: '0px' }}>
          <p>© 2025 Seedlogix Resources India Private Limited. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
